import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Track} from '../model/track';
import {Id} from '../model/id';
import {TrackEditInfo} from "../model/track-edit-info";

@Injectable()
export class TrackService {
  constructor(private httpClient : HttpClient) {}

  private baseUrl = `/api/admin/track`;

  create(trackEditInfo: TrackEditInfo) : Promise<Id> {
    return this.httpClient.post<Id>(this.baseUrl, trackEditInfo).toPromise();
  }

  list() : Observable<Track[]> {
    return this.httpClient.get<Track[]>(this.baseUrl);
  }

  delete(track_id : string) : Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/${track_id}`);
  }

  getTrackEdit(track_id: string): Promise<TrackEditInfo> {
    return this.httpClient.get<TrackEditInfo>(`${this.baseUrl}/${track_id}`).toPromise();
  }

  update(trackEditInfo: TrackEditInfo): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/${trackEditInfo.id}`, trackEditInfo).toPromise();
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/track.service.ts